// extracted by mini-css-extract-plugin
module.exports = {"clickable":"IconicButton_clickable__YeoMk","iconic__btn":"IconicButton_iconic__btn__3MB7Z","icon":"IconicButton_icon__3o4qg"};